import axios from "axios";
import { Auth } from "aws-amplify";
import { logApiCall } from "../../utils/apiLogger";
import log from "../../utils/logger";

import awsconfig from "../../config/aws-exports";

const API_ENDPOINT = awsconfig.API.endpoints[0].endpoint;

const api = axios.create({
  baseURL: `${API_ENDPOINT}/`,  // Add trailing slash after /dev
  timeout: 10000,
});

api.interceptors.request.use(
  async (config) => {
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      config.headers = {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      log.debug("API Request", {
        method: config.method,
        url: `${config.baseURL}${config.url}`,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token.substring(0, 20)}...`,
        },
        data: config.data,
      });
    } catch (error) {
      log.error("Error setting auth token:", error);
    }
    return config;
  },
  (error) => {
    log.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    logApiCall(
      response.config.method,
      `${response.config.baseURL}${response.config.url}`,
      response.config.data,
      response
    );
    return response;
  },
  (error) => {
    logApiCall(
      error.config.method,
      `${error.config.baseURL}${error.config.url}`,
      error.config.data,
      error.response,
      error
    );
    return Promise.reject(error);
  }
);

// Agent Conversations API Methods
export const getConversationForMatch = (matchPairId) =>
  api.get(`agent-conversations/match/${matchPairId}/conversation`);

export const getTranscript = (conversationId) =>
  api.get(`agent-conversations/conversation/${conversationId}/transcript`);

export const getAudioUrl = (conversationId, expiresIn = 3600) =>
  api.get(`agent-conversations/conversation/${conversationId}/audio`, { params: { expires_in: expiresIn } });

export const getEventConversations = (eventId) =>
  api.get(`agent-conversations/event/${eventId}/conversations`);

export const updateUserExclusionCriteria = (criteria) =>
  api.put('agent-conversations/user/exclusion-criteria', { exclusion_criteria: criteria });

export const updateNexusExclusionCriteria = (eventId, criteria) =>
  api.put(`agent-conversations/event/${eventId}/exclusion-criteria`, { exclusion_criteria: criteria });

export default api;
